import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useCategories } from '../context/CategoryContext'; // Adjust the import path as necessary
import FooterNav from '../components/layout/FooterNav'; // Adjust the import path as necessary

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #333;
  color: #fff;
`;



const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  color: #ff6b6b;
  margin: 0;
`;

const ErrorMessage = styled.h2`
  font-size: 24px;
  color: #feca57;
  margin: 20px 0;
`;

const ErrorDescription = styled.p`
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto 30px;
`;




const HomeButton = styled(Link)`
  background-color: #ff6b6b;
  color: white;
  padding: 10px 30px;
  text-decoration: none;
  border-radius: 25px;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ff5252;
  }
`;

const MobileFooter = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

const NotFound = () => {
  const { loading } = useCategories();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <PageWrapper>
      
      <ContentArea>
        <ErrorCode>404</ErrorCode>
        <ErrorMessage>Oops! This cut isn't on our menu.</ErrorMessage>
        <ErrorDescription>
          We couldn't find the page you're looking for. But don't worry, we've got plenty of fresh, halal options for you!
        </ErrorDescription>
      
        <HomeButton to="/">Back to Fresh Selection</HomeButton>
      </ContentArea>
      <MobileFooter>
        <FooterNav />
      </MobileFooter>
    </PageWrapper>
  );
};

export default NotFound;